import SearchIcon from '@mui/icons-material/Search'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'

type Props = Readonly<{
  value: string
  onChange: (value: string) => void
}>

export function TemplateLibrarySearch({ value, onChange }: Props) {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search templates"
      data-testid="instrument-template-library-search"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 20, color: '#94a3b8' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        mb: 3,
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          bgcolor: '#ffffff',
        },
      }}
    />
  )
}
